import {Dashboard} from 'components/QualityAssurance';
import {connect} from 'react-redux';
import {getCaseTimeLogByUserPayPeriod} from 'actions/casetimelog';

const mapStateToProps = (state) =>  {
    return {
        // Placeholder for eventual QA actions and state        
        isFetchingTimeLogs: state.caseTimeLog.isFetchingTimeLogs
    };
};

const mapDispatchToProps = (dispatch) => ({
    // Placeholder for eventual QA actions and state    
    getCaseTimeLogByUserPayPeriod (internetUserId, payPeriodId) {
        dispatch(getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);